/**
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 * Sectors - Kimonyi 
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 */
module.exports = {
  "Birira": ["Gakoro", "Kabagoyi", "Kadahenda", "Mbugayera", "Rurembo"],
  "Buramira": ["Kabaya", "Kagwene", "Kamugeni", "Nyiramuyenzi", "Ruhinga"],
  "Kivumu": ["Masoro", "Muregeya", "Musezero", "Ndorahe", "Nyamugari"],
  "Mbizi": ["Buhuma", "Bushubi", "Gatumo", "Rugondo"]
};